import React from 'react';
import SvgIcon from './SvgIcon';

const Explosion = props => (
    <SvgIcon viewBox="0 0 24 24" {...props}>
        <path
            d="M20.75 3a2 2 0 11-4 0 2.5 2.5 0 00-5 0v1.5"
            stroke="currentColor"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="M14.882 7.1a1 1 0 01-.632-.93V5.5a1 1 0 00-1-1h-3a1 1 0 00-1 1v.666a1 1 0 01-.632.93 8.5 8.5 0 106.264 0V7.1z"
            stroke="currentColor"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </SvgIcon>
);

Explosion.displayName = 'ExplosionIcon';

export default Explosion;
